export default {
  assignments: state => state.assignments,

  currentAssignmentArea: state => state.currentAssignmentArea,
  currentSubArea: state => state.currentSubArea,

  userToAssign: state => state.userToAssign
}
